<template>
  <transition>
    <div>

      <!-- ══════════════════════════════════════
           MOBILE / TABLET HEADER
      ══════════════════════════════════════ -->
      <div v-if="isMobileOrTablet">
        <nav class="hdr-mobile fixed-top" ref="hdrMobile">

          <!-- Status Bars (Mobile) -->
          <template v-if="!getIsUserDivyAdmin">

            <!-- Holiday Notice — marquee on mobile too -->
            <div v-if="showHolidayBanner" class="hdr-marquee-bar hdr-marquee-bar--notice">
              <div class="hdr-marquee-track">
                <span class="hdr-marquee-content">
                  <span class="hdr-marquee-badge">
                    <svg width="10" height="10" viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 3a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4zm0 7.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/></svg>
                    Note
                  </span>
                  Divvy Engagement Solutions
                  <strong>will be closed on Friday, July 3rd in observance of Independence Day.</strong>
                  However, your rewards platform (Incentiveweb) will remain available.
                </span>
              </div>
            </div>

            <!-- Pentair Note -->
            <!-- Pentair Note -->
            <div v-if="companyName == 'Pentair'" class="hdr-marquee-bar hdr-marquee-bar--info">
              <div class="hdr-marquee-track">
                <span class="hdr-marquee-content hdr-marquee-content--slow">
                  <span class="hdr-marquee-badge hdr-marquee-badge--info">
                    <svg width="10" height="10" viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm-.75 3.75a.75.75 0 0 1 1.5 0v1a.75.75 0 0 1-1.5 0v-1zM8 9a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 8 9z"/></svg>
                    Note
                  </span>
                  $1 earned as a reward in the myHC360+ app = 1 Rewards Mall point.
                  <span class="hdr-marquee-sep">•</span>
                  Gift cards must be activated within 120 days of issuance or all rights will lapse.
                </span>
              </div>
            </div>

          </template>

          <!-- Main bar -->
          <div class="hdr-mobile-bar">
            <div class="hdr-mobile-logo">
              <router-link :to="{ name: 'Home' }">
                <img :alt="companyName" :src="companyLogoUrl" class="logo" />
              </router-link>
            </div>
            <div class="hdr-mobile-actions">
              <button class="hdr-icon-btn" v-on:click="toggleSearchBar" aria-label="Search">
                <font-awesome-icon icon="search" />
              </button>
              <template v-if="!getIsUserDivyAdmin">
                <router-link v-if="cartItems >= 1" :to="{ name: 'Cart' }" class="hdr-icon-btn" aria-label="Cart">
                  <font-awesome-icon icon="shopping-cart" />
                  <span class="hdr-badge">{{ cartItems | numToLocale }}</span>
                </router-link>
                <router-link v-else :to="{ name: 'Cart' }" class="hdr-icon-btn" aria-label="Cart">
                  <font-awesome-icon icon="shopping-cart" />
                </router-link>
              </template>
              <router-link class="hdr-icon-btn" :to="{ name: 'Wishlist' }" aria-label="Wishlist">
                <font-awesome-layers class="fa">
                  <font-awesome-icon icon="clipboard-list" />
                  <font-awesome-icon class="fa-inverse" icon="heart" transform="shrink-4 down-5 right-8" />
                  <font-awesome-icon icon="heart" transform="shrink-7 down-5 right-8" />
                </font-awesome-layers>
                <span v-if="wishlistItems >= 1" class="hdr-badge">{{ wishlistItems | numToLocale }}</span>
              </router-link>
              <button
                class="hdr-icon-btn"
                aria-controls="mainMenuNavbar"
                aria-expanded="false"
                aria-label="Toggle navigation"
                data-target="#mainMenuNavbar"
                data-toggle="collapse"
                type="button"
              >
                <font-awesome-icon icon="user" />
              </button>
            </div>
          </div>

          <!-- Points row -->
          <!-- Points row — always visible -->
          <div class="hdr-mobile-pts" v-if="!getIsUserDivyAdmin">
            <router-link :to="{ name: 'AccountHistory' }" class="hdr-points-link">
              <span class="pts-chip">
                <span class="pts-star">✦</span>
                <strong>{{ userPointsAvailable | numToLocale }}</strong> pts
              </span>
            </router-link>

            <!-- Bonus / Swag points — always visible, outside menu -->
            <router-link
              v-if="bonusPointsEnabled"
              :to="{ name: 'Bonus Points' }"
              class="hdr-swag-chip"
            >
              <font-awesome-icon :icon="bonusPointsIconClass" />
              <strong>{{ bonusPointsAvailable | numToLocale }}</strong>
              <span>{{ bonusPointsAlias }}</span>
            </router-link>
          </div>

          <!-- Search bar -->
          <div class="hdr-mobile-search" v-if="!getIsUserDivyAdmin && isSearchVisible">
            <form action="/shop" class="hdr-search-form">
              <font-awesome-icon icon="search" class="hdr-search-icon" />
              <input
                :value="searchFilter"
                aria-label="Search"
                class="hdr-search-input"
                name="search"
                placeholder="Search products…"
                type="text"
              />
            </form>
          </div>

          <!-- Collapsible user menu -->
          <div id="mainMenuNavbar" class="collapse navbar-collapse hdr-mobile-menu">
            <div class="hdr-menu-inner">
              <div class="hdr-menu-user">
                <div class="hdr-menu-avatar">
                  <font-awesome-icon icon="user" />
                </div>
                <p class="hdr-menu-name">{{ userName }}</p>
              </div>
              <div class="hdr-menu-divider"></div>
              <!--<div v-if="userIsAdmin" class="hdr-menu-item" v-on:click="openWebsite">
                <font-awesome-icon icon="wrench" />
                <span>Admin menu</span>
              </div>
              <div class="hdr-menu-divider" v-if="userIsAdmin"></div>-->
              <div class="hdr-menu-item" v-on:click="goToAccount">
                <font-awesome-icon icon="user-cog" transform="shrink-2" />
                <span>My account</span>
              </div>
              <div class="hdr-menu-divider"></div>
              <div class="hdr-menu-item">
                <a v-b-modal.feedback href="#" class="hdr-menu-link">
                  <font-awesome-icon icon="question-circle" transform="shrink-2" />
                  <span>Help Center</span>
                </a>
              </div>
              <div class="hdr-menu-divider"></div>
              <div class="hdr-menu-item hdr-menu-item--danger" @click="logout()">
                <font-awesome-icon icon="sign-out-alt" transform="shrink-2" />
                <span>Log out</span>
              </div>
            </div>
          </div>

        </nav>
      </div>

      <!-- ══════════════════════════════════════
           DESKTOP HEADER
      ══════════════════════════════════════ -->
      <div v-else>
        <!--
          hdr-desktop-fixed owns fixed-top so status bars + navbar
          are ONE stacked fixed block. applyBodyOffset() measures its
          real height and sets body padding-top exactly — no overlap,
          no extra gap, works whether 0, 1 or 2 bars are visible.
        -->
        <div class="hdr-desktop-fixed fixed-top" ref="hdrFixed">

          <!-- Status Bars -->
          <template v-if="!getIsUserDivyAdmin">

            <!-- Holiday Notice — marquee scrolling -->
            <div v-if="showHolidayBanner" class="hdr-marquee-bar hdr-marquee-bar--notice">
              <div class="hdr-marquee-track">
                <span class="hdr-marquee-content">
                  <span class="hdr-marquee-badge">
                    <svg width="10" height="10" viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm0 3a.75.75 0 0 1 .75.75v3.5a.75.75 0 0 1-1.5 0v-3.5A.75.75 0 0 1 8 4zm0 7.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"/></svg>
                    Note
                  </span>
                  Divvy Engagement Solutions
                  <strong>will be closed on Friday, July 3rd in observance of Independence Day.</strong>
                  However, your rewards platform (Incentiveweb) will remain available.
                </span>
              </div>
              <button class="hdr-marquee-close" @click="dismissHolidayBanner" aria-label="Dismiss notice">
                <svg width="9" height="9" viewBox="0 0 10 10" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
                  <line x1="1" y1="1" x2="9" y2="9"/><line x1="9" y1="1" x2="1" y2="9"/>
                </svg>
              </button>
            </div>

            <!-- Pentair Note — marquee scrolling -->
            <div v-if="companyName == 'Pentair'" class="hdr-marquee-bar hdr-marquee-bar--info">
              <div class="hdr-marquee-track">
                <span class="hdr-marquee-content hdr-marquee-content--slow">
                  <span class="hdr-marquee-badge hdr-marquee-badge--info">
                    <svg width="10" height="10" viewBox="0 0 16 16" fill="currentColor"><path d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1zm-.75 3.75a.75.75 0 0 1 1.5 0v1a.75.75 0 0 1-1.5 0v-1zM8 9a.75.75 0 0 1 .75.75v2.5a.75.75 0 0 1-1.5 0v-2.5A.75.75 0 0 1 8 9z"/></svg>
                    Note
                  </span>
                  $1 earned as a reward in the myHC360+ app = 1 Rewards Mall point.
                  <span class="hdr-marquee-sep">•</span>
                  Gift cards must be activated within 120 days of issuance or all rights will lapse.
                </span>
              </div>
            </div>

          </template>

          <!-- Main navbar — plain block, no fixed-top here -->
          <nav class="hdr-desktop navbar navbar-expand-md navbar-light">
            <div class="hdr-desktop-inner container d-flex align-items-center">

              <!-- Logo -->
              <div class="hdr-logo-wrap">
                <router-link :to="{ name: 'Home' }">
                  <img :alt="companyName" :src="companyLogoUrl" class="logo" />
                </router-link>
              </div>

              <!-- Hamburger -->
              <button
                aria-controls="mainMenuNavbar"
                aria-expanded="false"
                aria-label="Toggle navigation"
                class="hdr-toggler navbar-toggler d-md-none"
                data-target="#mainMenuNavbar"
                data-toggle="collapse"
                type="button"
              >
                <span class="navbar-toggler-icon"></span>
              </button>

              <div
                id="mainMenuNavbar"
                class="collapse navbar-collapse hdr-collapse d-md-flex"
                :style="{ justifyContent: getIsUserDivyAdmin ? 'flex-end' : 'unset' }"
              >
                <!-- Primary nav links -->
                <ul class="hdr-nav-main navbar-nav mr-auto ml-md-4" v-if="!getIsUserDivyAdmin">
                  <li class="nav-item">
                    <router-link class="hdr-nav-link d-none d-sm-inline-flex" :to="{ name: 'Home' }">
                      <font-awesome-icon icon="home" />
                    </router-link>
                  </li>
                  <li class="nav-item">
                    <router-link
                      class="hdr-nav-link"
                      v-if="[500387,500085,500087,252,500247,500030,500268,500199,500200,500053,500340,500355,500333,500289].includes(client)"
                      :to="{ name: 'Category', params: { categoryId: 20254 } }"
                    >Shop</router-link>
                    <router-link class="hdr-nav-link" v-else :to="{ name: 'Category', params: { categoryId: 1 } }">Shop</router-link>
                  </li>
                  <li class="nav-item">
                    <router-link class="hdr-nav-link" :to="{ name: 'ProgramMenu' }">Program</router-link>
                  </li>
                  <li class="nav-item" v-if="recognitionEnabled">
                    <router-link class="hdr-nav-link" :to="{ name: 'RecognitionFeed' }">Recognition</router-link>
                  </li>
                  <li v-if="bonusPointsEnabled" class="nav-item">
                    <router-link class="hdr-nav-link" :to="{ name: 'Bonus Points' }">{{ bonusPointsMenuItem }}</router-link>
                  </li>
                </ul>

                <!-- Search -->
                <form action="/shop" class="hdr-search-wrap" v-if="!getIsUserDivyAdmin">
                  <font-awesome-icon icon="search" class="hdr-search-icon" />
                  <input
                    :value="searchFilter"
                    aria-label="Search"
                    class="hdr-search-input"
                    name="search"
                    placeholder="Search products"
                    type="text"
                  />
                </form>

                <!-- Right side nav -->
                <ul class="hdr-nav-info navbar-nav align-items-center">

                  <!-- Cart -->
                  <li class="nav-item" v-if="!getIsUserDivyAdmin">
                    <router-link v-if="cartItems >= 1" class="hdr-action-btn" :to="{ name: 'Cart' }">
                      <span class="hdr-icon-wrap">
                        <font-awesome-icon icon="shopping-cart" />
                        <span class="hdr-badge">{{ cartItems | numToLocale }}</span>
                      </span>
                      <strong class="ml-1">{{ cartTotalPoints | numToLocale }}</strong>
                      <em>pts</em>
                    </router-link>
                    <router-link v-else class="hdr-action-btn" :to="{ name: 'Cart' }">
                      <font-awesome-icon icon="shopping-cart" />
                    </router-link>
                  </li>

                  <!-- Wishlist -->
                  <li class="nav-item" v-if="!getIsUserDivyAdmin">
                    <router-link class="hdr-action-btn" :to="{ name: 'Wishlist' }">
                      <span class="hdr-icon-wrap">
                        <font-awesome-layers class="fa">
                          <font-awesome-icon icon="clipboard-list" />
                          <font-awesome-icon class="fa-inverse" icon="heart" transform="shrink-4 down-5 right-8" />
                          <font-awesome-icon icon="heart" transform="shrink-7 down-5 right-8" />
                        </font-awesome-layers>
                        <span v-if="wishlistItems >= 1" class="hdr-badge">{{ wishlistItems | numToLocale }}</span>
                      </span>
                      <em class="ml-1">Wishlist</em>
                    </router-link>
                  </li>

                  <!-- User dropdown -->
                  <b-nav-item-dropdown id="user-dropdown" class="hdr-user-dropdown">
                    <template v-slot:button-content>
                      <span class="hdr-user-btn">
                        <span class="hdr-user-avatar">
                          <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="user" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" class="svg-inline--fa fa-user fa-w-14"><path fill="currentColor" d="M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z" class=""></path></svg>
                        </span>
                        <em class="hdr-user-name">{{ userName }}</em>
                      </span>
                    </template>
                    <b-dropdown-item v-if="userIsAdmin" v-on:click="openWebsite">
                      <font-awesome-icon icon="wrench" transform="shrink-2" class="mr-2" />Admin menu
                    </b-dropdown-item>
                    <b-dropdown-item to="/divvyadmin" v-if="getIsUserDivyAdmin && !userIsAdmin">
                      <font-awesome-icon icon="wrench" transform="shrink-2" class="mr-2" />Divvy Admin
                    </b-dropdown-item>
                    <b-dropdown-item to="/history">
                      <font-awesome-icon icon="user-cog" transform="shrink-2" class="mr-2" />My account
                    </b-dropdown-item>
                    <b-dropdown-item v-b-modal.feedback href="#">
                      <font-awesome-icon icon="question-circle" transform="shrink-2" class="mr-2" />Help Center
                    </b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="logout()" class="hdr-dropdown-danger">
                      <font-awesome-icon icon="sign-out-alt" transform="shrink-2" class="mr-2" />Log out
                    </b-dropdown-item>
                  </b-nav-item-dropdown>

                  <!-- Points balance -->
                  <li class="hdr-points-pill" v-if="!getIsUserDivyAdmin">
                    <router-link :to="{ name: 'AccountHistory' }" class="hdr-points-link">
                      <span class="pts-star">✦</span>
                      <strong>{{ userPointsAvailable | numToLocale }}</strong>
                      <span>pts</span>
                    </router-link>
                  </li>

                  <!-- Bonus points -->
                  <li v-if="bonusPointsEnabled" class="bonus-points nav-item">
                    <router-link
                      :to="{ name: 'Bonus Points' }"
                      id="userDropdown"
                      aria-expanded="false"
                      aria-haspopup="true"
                      data-toggle="dropdown"
                    >
                      <font-awesome-icon :icon="bonusPointsIconClass" transform="grow-7" class="d-inline" />
                      <strong>{{ bonusPointsAvailable | numToLocale }}</strong><br />{{ bonusPointsAlias }}
                    </router-link>
                  </li>

                </ul>
              </div>
            </div>
          </nav>

        </div><!-- /.hdr-desktop-fixed -->
      </div>

    </div>
  </transition>
</template>

<script>
import { mapState } from "vuex";
import { isMobile, isTablet } from "mobile-device-detect";
import StatusBar from "@/components/StatusBar.vue";
import RecognitionChallengesService from "@/services/RecognitionChallengesService";

export default {
  props: {
    searchFilter: String,
  },
  components: {
    StatusBar,
  },
  computed: {
    ...mapState({
      companyName: (state) => state.company.name,
      companyLogoUrl: (state) => state.company.logoUrl,
      grossUpTaxes: (state) => state.company.grossUpTaxes,

      bonusPointsEnabled: (state) => state.company.bonusPointsIsEnabled,
      bonusPointsMenuItem: (state) => state.company.bonusPointsMenuItem,
      bonusPointsIconClass: (state) => state.company.bonusPointsIconClass,
      bonusPointsAlias: (state) => state.company.bonusPointsPointsAlias,
      bonusPointsAvailable: (state) => state.user.bonusPointsAvailable,
      userName: (state) => state.user.profile.firstName,
      client: (state) => state.user.profile.clientId,
      userPoints: (state) => state.user.profile.pointsAvailable,
      userIsAdmin: (state) => state.user.profile.isAdmin,

      cartItems: (state) => state.cart.summary.items,
      cartProductPoints: (state) => state.cart.summary.productPoints,
      cartTaxPoints: (state) => state.cart.summary.taxPoints,

      unapprovedProductPoints: (state) => state.cart.unapproved.productPoints,

      wishlistItems: (state) => state.wishlist.summary.items,
    }),
    cartTotalPoints: function () {
      if (this.grossUpTaxes) {
        return this.cartProductPoints + this.cartTaxPoints;
      } else {
        return this.cartProductPoints;
      }
    },
    userPointsAvailable: function () {
      return this.userPoints - this.unapprovedProductPoints;
    },
    getUserDetail() {
      return this.$store.getters["user/getUserClients"];
    },
    getIsUserDivyAdmin() {
      return this.$store.getters["user/getIsUserDivyAdmin"];
    },
    canShowTravelSunsetBanner() {
      return this.$store.getters["user/canShowTravelSunsetBanner"];
    },
    isMobileOrTablet: function () {
      return isMobile || isTablet;
    },
  },
  data() {
    return {
      isSearchVisible: false,
      showHolidayBanner: false, // ← control holiday notice visibility
      recognitionEnabled: false,
    };
  },
  methods: {
    logout: function () {
      localStorage.removeItem("isDivvyAdmin");
      this.$store
        .dispatch("auth/logOut")
        .then(() => {
          window.location.href = "/login";
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toggleSearchBar() {
      this.isSearchVisible = !this.isSearchVisible;
    },
    /* Dismiss holiday banner and immediately re-measure header height */
    dismissHolidayBanner() {
      this.showHolidayBanner = false;
      this.$nextTick(() => this.applyBodyOffset());
    },
    openWebsite: function () {
      if (this.getUserDetail.hasAccessToNewApp) {
        this.$router.push({ name: "AdminTransactionReport" });
      } else {
        this.$store
          .dispatch("auth/fetchLegacyAccessToken")
          .then((accessToken) => {
            window.open(accessToken.loginUrl, "_blank");
          })
          .catch(() => {
            this.showError("Failed to launch legacy website");
          });
      }
    },
    goToAccount: function () {
      this.$router.push({ name: "AccountHistory" });
    },
    openLegacyWebsite: function () {
      this.$store
        .dispatch("auth/fetchLegacyAccessToken")
        .then((accessToken) => {
          window.open(accessToken.loginUrl, "_blank");
        })
        .catch(() => {
          this.showError("Failed to launch legacy website");
        });
    },
    showSuccess: function (message, onClose) {
      this.$bvModal
        .msgBoxOk(message, {
          size: "sm",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then(() => {
          onClose();
        });
    },
    showError: function (message) {
      this.$bvModal.msgBoxOk(message, {
        size: "sm",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        okVariant: "danger",
        centered: true,
      });
    },
    /*
      Measures the real pixel height of the entire fixed header block
      (status bars + navbar) and writes it to body padding-top.
      Called on mount, resize, route change, and after any banner dismiss.
      This is the ONLY thing that prevents page content from being hidden.
    */
    applyBodyOffset() {
      const el = this.$refs.hdrFixed || this.$refs.hdrMobile;
      if (!el) return;
      const h = el.getBoundingClientRect().height;
      // Guard: only apply if height is a real rendered value (> 10px, < 300px)
      if (h > 10 && h < 300) {
        document.body.style.paddingTop = Math.round(h) + "px";
      }
    },
    fetchRecognitionStatus() {
      if (this.client) {
        RecognitionChallengesService.getModuleStatus(this.client)
          .then((resp) => {
            this.recognitionEnabled = resp.data.data.isEnabled;
          })
          .catch(() => {
            this.recognitionEnabled = false;
          });
      }
    }
  },
  // Add watcher
  watch: {
    client(val) {
      if (val) this.fetchRecognitionStatus();
    }
  },
  mounted() {
    this.$nextTick(() => this.applyBodyOffset());
    window.addEventListener("resize", this.applyBodyOffset);
    /* Re-measure on every route change (bars may show/hide per page) */
    this.$router.afterEach(() => {
      this.$nextTick(() => this.applyBodyOffset());
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.applyBodyOffset);
    document.body.style.paddingTop = "";
  },
  created() {
    localStorage.getItem("sidebarSubModules") ||
      this.$store.dispatch("fetchSidebarModules", { ishradmin: true });
    localStorage.getItem("isDivvyAdmin")
      ? this.$store.dispatch("user/fetchAdminProfile")
      : this.$store.dispatch("user/fetchProfile");
    localStorage.getItem("isDivvyAdmin") ||
      this.$store.dispatch("company/fetchCompany");
    this.$store.dispatch("company/fetchBonusPointsConfig");
    this.$store.dispatch("user/fetchBonusPoints");
    this.$store.dispatch("cart/fetchCartSummary");
    this.$store.dispatch("cart/fetchCartUnapproved");
    this.$store.dispatch("wishlist/fetchWishlistSummary");
    this.fetchRecognitionStatus();
  },
};
</script>

<style lang="scss">

/* ══════════════════════════════════════════════════
   SHARED
══════════════════════════════════════════════════ */
.logo {
  width: auto;
  max-width: 100%;
  max-height: 38px;
  display: block;
}

.hdr-icon-wrap {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 4px;
}

.hdr-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background-color: #e53935;
  color: #fff;
  font-size: 9px;
  font-weight: 800;
  line-height: 1;
  min-width: 15px;
  height: 15px;
  border-radius: 50%;
  padding: 0 3px;
  position: absolute;
  top: -9px;
  right: -10px;
  pointer-events: none;
}

.hdr-icon-btn {
  .hdr-badge {
    top: 2px;
    right: 2px;
  }
}

.pts-star {
  font-size: 0.6rem;
  opacity: 0.7;
  margin-right: 2px;
}


/* ══════════════════════════════════════════════════
   MARQUEE STATUS BARS
   Pure CSS infinite scroll — no JS needed.
   Works for both desktop and mobile.
══════════════════════════════════════════════════ */
.hdr-marquee-bar {
  width: 100%;
  height: 32px;
  display: flex;
  align-items: center;
  overflow: hidden;
  position: relative;
  border-bottom: 1px solid transparent;
  flex-shrink: 0;
}

.hdr-marquee-bar--notice {
  background-color: #fff8e6;
  border-bottom-color: #f5d878;
  border-left: 3px solid #f5a623;
}

.hdr-marquee-bar--info {
  background-color: #a1bee9;
  border-bottom-color: #b8d4fb;
  border-left: 3px solid #3b82f6;
}

/* Scrolling track — clips the moving content */
.hdr-marquee-track {
  flex: 1;
  overflow: hidden;
  white-space: nowrap;
  padding-left: 10px;
}

/* Status bar content — static, no scroll animation */
.hdr-marquee-content {
  display: inline-block;
  white-space: nowrap;
  font-size: 12.5px;
  color: #3a3a3a;
  line-height: 32px;

  strong {
    font-weight: 700;
    color: #1a1a1a;
  }

  &--slow { /* kept for compatibility, no effect without animation */ }
}

/* Type badge pill inside the marquee */
.hdr-marquee-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 9px;
  font-weight: 800;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  padding: 1px 7px 1px 5px;
  border-radius: 3px;
  background-color: #f5a623;
  color: #fff;
  margin-right: 8px;
  vertical-align: middle;
  line-height: 1.8;

  svg { flex-shrink: 0; }

  &--info {
    background-color: #3b82f6;
  }
}

/* Dismiss × button — only on holiday notice */
.hdr-marquee-close {
  flex-shrink: 0;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 4px;
  color: #aaa;
  cursor: pointer;
  padding: 0;
  margin: 0 6px;
  transition: background 0.15s, color 0.15s;

  &:hover {
    background: rgba(0, 0, 0, 0.07);
    color: #555;
  }
}


/* ══════════════════════════════════════════════════
   DESKTOP HEADER
   hdr-desktop-fixed  → owns fixed-top, wraps bars + nav
   hdr-desktop (nav)  → plain block, no position
══════════════════════════════════════════════════ */
.hdr-desktop-fixed {
  width: 100%;
  z-index: 1030;
  background: #ffffff;
  border-bottom: 1px solid #ebebeb;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.06);
}

.hdr-desktop {
  background: #ffffff !important;
  width: 100%;
  padding: 0 !important;
  box-shadow: none !important;
  border-bottom: none !important;
}

.hdr-desktop-inner {
  padding-top: 0.55rem;
  padding-bottom: 0.55rem;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
  gap: 0.5rem;
}

.hdr-logo-wrap {
  flex-shrink: 0;
  max-width: 180px;
}

.hdr-collapse {
  display: flex;
  align-items: center;
  flex: 1;
}

/* Primary nav */
.hdr-nav-main {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 0.25rem;

  .nav-item { margin: 0; }

  .hdr-nav-link {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.4rem 0.75rem;
    font-size: 0.88rem;
    font-weight: 600;
    color: #444;
    border-radius: 8px;
    text-decoration: none;
    transition: background 0.18s, color 0.18s;
    white-space: nowrap;

    &:hover {
      background: #f4f6f9;
      color: $primary;
    }

    &.router-link-exact-active {
      color: $primary;
      background: rgba($primary, 0.07);
      position: relative;

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 2px;
        background: $primary;
        border-radius: 2px;
      }
    }
  }
}

/* Search */
.hdr-search-wrap {
  display: flex;
  align-items: center;
  position: relative;
  flex: 1;
  max-width: 280px;
  margin: 0 0.75rem;

  .hdr-search-icon {
    position: absolute;
    left: 12px;
    color: #aaa;
    font-size: 0.8rem;
    pointer-events: none;
  }

  .hdr-search-input {
    width: 100%;
    padding: 0.45rem 1rem 0.45rem 2.2rem;
    border: 1px solid #e4e4e4;
    border-radius: 50px;
    font-size: 0.83rem;
    background: #f8f9fb;
    color: #333;
    outline: none;
    transition: border-color 0.2s, box-shadow 0.2s;

    &::placeholder { color: #bbb; }

    &:focus {
      border-color: $primary;
      background: #fff;
      box-shadow: 0 0 0 3px rgba($primary, 0.1);
    }
  }
}

/* Right action buttons */
.hdr-nav-info {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 0.15rem;

  .nav-item { position: relative; }

  .hdr-action-btn {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.4rem 0.65rem;
    border-radius: 8px;
    font-size: 0.83rem;
    font-weight: 500;
    color: #555;
    text-decoration: none;
    background: #f8f9fb;
    border: 1px solid #ebebeb;
    transition: background 0.18s, color 0.18s, border-color 0.18s;
    position: relative;
    white-space: nowrap;

    em { font-style: normal; font-weight: 400; }
    strong { font-weight: 700; }

    &:hover,
    &.router-link-exact-active {
      background: $primary;
      color: #fff;
      border-color: $primary;
      .fa-inverse { color: $primary; }
    }
  }
}

/* User dropdown button */
.hdr-user-dropdown {
  > a.nav-link {
    padding: 0 !important;
    background: transparent !important;
    border: none !important;
    box-shadow: none !important;
  }
}

.hdr-user-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.20rem;
  padding: 0.20rem 0.7rem;
  border-radius: 8px;
  background: #f8f9fb;
  border: 1px solid #ebebeb;
  cursor: pointer;
  transition: background 0.18s, border-color 0.18s;

  &:hover { background: #eef1f5; border-color: #d0d0d0; }
}

.hdr-user-avatar {
  width: 26px;
  height: 26px;
  color: #555;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.hdr-user-name {
  font-style: normal;
  font-size: 0.83rem;
  font-weight: 600;
  color: #444;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* Dropdown menu */
.navbar.bg-white .dropdown-menu,
.hdr-desktop .dropdown-menu {
  background: #f0f9ff;
  border: none;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(0,0,0,0.12);
  padding: 0.4rem 0;
  min-width: 180px;
  overflow: hidden;

  .dropdown-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.55rem 1.1rem;
    font-size: 0.85rem;
    font-weight: 500;
    color: #444;
    border-radius: 0;
    transition: background 0.15s;

    &:hover {
      background: rgba($primary, 0.07);
      color: $primary;
    }
  }

  .dropdown-divider { margin: 0.2rem 0; border-color: #f0f0f0; }
}

.hdr-dropdown-danger .dropdown-item {
  color: #e53935 !important;
  &:hover { background: rgba(#e53935, 0.07) !important; color: #e53935 !important; }
}

/* Points pill */
.hdr-points-pill {
  list-style: none;

  .hdr-points-link {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.38rem 0.85rem;
    border-radius: 50px;
    font-size: 0.82rem;
    font-weight: 600;
    text-decoration: none;
    transition: filter 0.18s;
    white-space: nowrap;

    strong { font-weight: 800; }
    &:hover { filter: brightness(1.1); }
  }
}

/* Bonus points */
.bonus-points {
  margin: 0 0 0 0.5rem;
  a {
    background-color: transparent !important;
    color: #f8a355 !important;
    font-size: 0.82rem;
    line-height: 1.1;
    &:hover { color: #c77c37 !important; }
  }
}

/* Toggler */
.hdr-toggler {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0.3rem 0.5rem;
}


/* ══════════════════════════════════════════════════
   MOBILE HEADER
══════════════════════════════════════════════════ */
.hdr-mobile {
  background: #ffffff;
  border-bottom: 1px solid #ebebeb;
  box-shadow: 0 1px 10px rgba(0,0,0,0.06);
  width: 100%;
  z-index: 1030;
}

.hdr-mobile-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.6rem 1rem;
  padding-bottom: unset;
}

.hdr-mobile-logo {
  flex-shrink: 0;
  max-width: 42%;
}

.hdr-mobile-actions {
  display: flex;
  align-items: center;
  gap: 0.1rem;
}

.hdr-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: transparent;
  border: none;
  color: #555;
  font-size: 0.95rem;
  cursor: pointer;
  position: relative;
  text-decoration: none;
  transition: background 0.15s;

  &:hover { background: #f4f6f9; color: $primary; }
  &.navbar-toggler { border: 1px solid #e4e4e4; }
}

.hdr-mobile-pts {
  display: flex;
  justify-content: flex-end;
  padding: 0 1rem 0.5rem;

  .pts-chip {
    display: inline-flex;
    align-items: center;
    gap: 0.2rem;
    color: #3782f3;
    font-size: 0.78rem;
    font-weight: 600;
    padding: 0.25rem 0.75rem;
    border-radius: 50px;

    strong { font-weight: 800; }
  }
}

.hdr-mobile-search {
  padding: 0 0.75rem 0.65rem;

  .hdr-search-form {
    display: flex;
    align-items: center;
    position: relative;

    .hdr-search-icon {
      position: absolute;
      left: 12px;
      color: #aaa;
      font-size: 0.78rem;
      pointer-events: none;
    }

    .hdr-search-input {
      width: 100%;
      padding: 0.5rem 1rem 0.5rem 2.2rem;
      border: 1px solid #e4e4e4;
      border-radius: 50px;
      font-size: 0.85rem;
      background: #f8f9fb;
      outline: none;

      &:focus {
        border-color: $primary;
        background: #fff;
        box-shadow: 0 0 0 3px rgba($primary, 0.1);
      }
    }
  }
}

.hdr-mobile-menu {
  border-top: 1px solid #f0f0f0;
}

.hdr-menu-inner {
  padding: 0.5rem 0 0.75rem;
  background: #fff;
}

.hdr-menu-user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.25rem;
}

.hdr-menu-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: $primary;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.85rem;
  flex-shrink: 0;
}

.hdr-menu-name {
  font-size: 1rem;
  font-weight: 700;
  color: #1a1a2e;
  margin: 0;
}

.hdr-menu-divider {
  height: 1px;
  background: #f3f3f3;
  margin: 0.15rem 0;
}

.hdr-menu-item {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  padding: 0.7rem 1.25rem;
  font-size: 0.88rem;
  font-weight: 500;
  color: #444;
  cursor: pointer;
  transition: background 0.15s;

  &:hover { background: #f8f9fb; color: $primary; }

  &--danger {
    color: #e53935;
    &:hover { background: rgba(#e53935, 0.05); color: #e53935; }
  }

  svg { width: 15px; color: inherit; }
}

.hdr-menu-link {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  color: #444;
  text-decoration: none;
  font-weight: 500;
  width: 100%;
  &:hover { color: $primary; }
}


/* ══════════════════════════════════════════════════
   RESPONSIVE OVERRIDES
══════════════════════════════════════════════════ */
@media all and (max-width: 1200px) and (min-width: 450px) {
  .hdr-desktop .dropdown-menu {
    box-shadow: none !important;
  }
  .hdr-action-btn {
    strong, em { display: none; }
    svg { margin-right: 0 !important; }
  }
  .hdr-points-pill { display: none; }
  .hdr-search-wrap { max-width: 200px; }
}

@media all and (max-width: 450px) {
  .hdr-mobile-logo { max-width: 45%; }
}

@media all and (min-width: 1070px) {
  .hdr-action-btn em,
  .hdr-action-btn strong {
    display: inline;
  }
}

/* Mobile: marquee slightly smaller */
@media all and (max-width: 767px) {
  .hdr-marquee-bar {
    height: auto;
    padding: 6px 10px;
  }
  .hdr-marquee-track {
    overflow: visible;
    white-space: normal;
  }
  .hdr-marquee-content {
    font-size: 11.5px;
    line-height: 1.45;
    white-space: normal;
    display: block;
  }
}

.modal-body {
  padding: 2rem 2rem 0 2rem !important;
}
.hdr-mobile-pts {
  display: flex;
  justify-content: flex-end;   // ← pts on left, swag on right
  align-items: center;
  padding: 0 1rem 0.5rem;
}

.hdr-swag-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  color: #f8a355;
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0.25rem 0.75rem;
  border-radius: 50px;
  text-decoration: none;
  border: 1px solid rgba(248, 163, 85, 0.3);
  background: rgba(248, 163, 85, 0.08);
  transition: background 0.15s;

  strong { font-weight: 800; }
  span   { font-weight: 500; }

  &:hover {
    background: rgba(248, 163, 85, 0.18);
    color: darken(#f8a355, 10%);
    text-decoration: none;
  }
}

.hdr-marquee-sep {
  display: inline-block;
  margin: 0 8px;
  opacity: 0.5;
  font-weight: 700;
}
</style>